import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { tanimlarApi } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const jsonHeaders = () => ({ ...headers(), 'Content-Type': 'application/json' });

// Modul adi gosterimi
const MODUL_ADLARI: Record<string, string> = {
  buyukbas: '🐄 Büyükbaş', kucukbas_koyun: '🐑 Küçükbaş Koyun',
  kucukbas_keci: '🐐 Küçükbaş Keçi', at: '🐎 At Yetiştiriciliği',
  ari: '🐝 Arıcılık', ceylan: '🦌 Asya Ceylanı', kopek: '🐕 Çoban Köpeği',
  tarla: '🌾 Tarla Bitkileri', yem: '🌿 Yem Bitkileri', bahce: '🌳 Bahçe Kültürleri',
};

// Hangi modül hangi modul_baglantisi degerlerini gostersin
const MODUL_BAGLANTI: Record<string, string[]> = {
  buyukbas:      ['buyukbas_irk', 'buyukbas_tur', 'buyukbas_grup', 'buyukbas_urun', 'buyukbas_satis'],
  kucukbas_koyun:['kucukbas_irk', 'kucukbas_tur', 'kucukbas_grup', 'kucukbas_urun', 'kucukbas_satis'],
  kucukbas_keci: ['kucukbas_irk', 'kucukbas_tur', 'kucukbas_grup', 'kucukbas_urun', 'kucukbas_satis'],
  at:            ['at_irk', 'at_tur', 'at_urun', 'at_satis'],
  ari:           ['ari_kovan', 'ari_tur', 'ari_urun', 'ari_satis'],
  ceylan:        ['ceylan_tur', 'diger_satis'],
  kopek:         ['kopek_tur', 'diger_satis'],
  tarla:         ['tarla_ekim', 'tarla_urun', 'tarla_amac'],
  yem:           ['yem_urun'],
  bahce:         ['bahce_urun'],
};

export default function IsletmeFaaliyetBagi() {
  const [faaliyetler, setFaaliyetler] = useState<any[]>([]);
  const [isletmeler,  setIsletmeler]  = useState<any[]>([]);
  const [filtreModul, setFiltreModul] = useState('');
  const [modalAcik,   setModalAcik]   = useState(false);
  const [form,        setForm]        = useState({ isletme_id: '', modul: 'buyukbas', kategori: '', aciklama: '' });
  const [hata,        setHata]        = useState('');
  const [mesaj,       setMesaj]       = useState('');

  // Kategori dropdown icin tanimlar
  const [tanimListesi, setTanimListesi] = useState<any[]>([]);
  const [tanimYukleniyor, setTanimYukleniyor] = useState(false);

  useEffect(() => {
    yukle();
    tanimlarApi.isletmelerListesi().then(r => setIsletmeler(r.data));
  }, []);

  useEffect(() => { yukle(); }, [filtreModul]);

  // Modul degisince tanimlari yukle
  useEffect(() => {
    if (!form.modul) return;
    setForm(prev => ({ ...prev, kategori: '' }));
    yikleTanimlar(form.modul);
  }, [form.modul]);

  const yukle = () => {
    const params: any = {};
    if (filtreModul) params.modul = filtreModul;
    axios.get(`${API}/api/faaliyetler/`, { headers: headers(), params })
      .then(r => setFaaliyetler(r.data));
  };

  const yikleTanimlar = async (modul: string) => {
    const baglantilar = MODUL_BAGLANTI[modul] || [];
    if (baglantilar.length === 0) { setTanimListesi([]); return; }
    setTanimYukleniyor(true);
    try {
      // Tum kayitlari cek (agac yapisi)
      const r = await fetch(`${API}/api/tanimlar2/liste?sadece_yaprak=false`, { headers: headers() });
      const tumListe: any[] = r.ok ? await r.json() : [];

      // Filtrele: sadece ilgili modul_baglantisi olanlari al
      const filtrelendi = tumListe.filter(t =>
        t.aktif !== 0 && t.aktif !== false &&
        baglantilar.includes(t.modul)
      );

      // Her kayit icin hiyerarsik yol olustur
      const kodMap: Record<string, any> = {};
      tumListe.forEach(t => { kodMap[t.kod] = t; });

      const yolOlustur = (t: any): string => {
        const parcalar: string[] = [];
        let k = t.ust_kod;
        while (k && kodMap[k]) {
          parcalar.unshift(kodMap[k].ad);
          k = kodMap[k].ust_kod;
          if (parcalar.length > 4) break; // max 4 seviye ust
        }
        return parcalar.length > 0
          ? parcalar.join(' > ') + ' > ' + t.ad
          : t.ad;
      }

      const sonListe = filtrelendi.map(t => ({
        ...t,
        gosterim: `${yolOlustur(t)}  (${t.kod})`,
      })).sort((a, b) => a.kod.localeCompare(b.kod));

      setTanimListesi(sonListe);
    } catch {
      setTanimListesi([]);
    }
    setTanimYukleniyor(false);
  };

  const ekle = async () => {
    if (!form.isletme_id || !form.modul) { setHata('İşletme ve modül seçiniz'); return; }
    setHata('');
    try {
      await axios.post(`${API}/api/faaliyetler/`, { ...form, isletme_id: Number(form.isletme_id) }, { headers: headers() });
      setMesaj('✅ Faaliyet eklendi'); yukle(); setModalAcik(false);
      setForm({ isletme_id: '', modul: 'buyukbas', kategori: '', aciklama: '' });
      setTimeout(() => setMesaj(''), 3000);
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
  };

  const toggle = async (id: number, aktif: boolean) => {
    await axios.put(`${API}/api/faaliyetler/${id}/toggle`, {}, { headers: headers() });
    yukle();
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu faaliyet tanımını silmek istiyor musunuz?')) return;
    await axios.delete(`${API}/api/faaliyetler/${id}`, { headers: headers() });
    yukle();
  };

  // Modüle göre grupla
  const gruplu: Record<string, any[]> = {};
  faaliyetler.forEach(f => {
    if (!gruplu[f.modul]) gruplu[f.modul] = [];
    gruplu[f.modul].push(f);
  });

  return (
    <div>
      <div className="page-header">
        <h1>İşletme Faaliyet Bağı</h1>
        <p>Her işletmenin hangi faaliyetleri yürüttüğünü buradan yönetin.</p>
      </div>

      {mesaj && <div className="alert" style={{ background: '#d5f5e3', color: '#1e8449', border: '1px solid #a9dfbf', padding: '10px 14px', borderRadius: 4, marginBottom: 14 }}>{mesaj}</div>}

      <div className="card">
        <div className="toolbar">
          <select className="search-input" style={{ width: 220 }} value={filtreModul}
            onChange={e => setFiltreModul(e.target.value)}>
            <option value="">Tüm Modüller</option>
            {Object.entries(MODUL_ADLARI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <button className="btn btn-success" onClick={() => { setHata(''); setModalAcik(true); yikleTanimlar(form.modul); }}>
            + Yeni Faaliyet Ekle
          </button>
        </div>

        {Object.entries(gruplu).map(([modul, items]) => (
          <div key={modul} style={{ marginBottom: 20 }}>
            <h2 style={{ fontSize: 14, color: '#1a5276', borderBottom: '2px solid #eaf0fb', paddingBottom: 6, marginBottom: 8 }}>
              {MODUL_ADLARI[modul] || modul}
            </h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr><th>İşletme</th><th>İl</th><th>Kategori/Irk</th><th>Açıklama</th><th>Durum</th><th>İşlem</th></tr>
                </thead>
                <tbody>
                  {items.map(f => (
                    <tr key={f.id} style={{ opacity: f.aktif ? 1 : 0.5 }}>
                      <td><strong>{f.isletme_kod}</strong> — {f.isletme_ad}</td>
                      <td>{f.isletme_il || ''}</td>
                      <td>{f.kategori || <em style={{ color: '#999' }}>—</em>}</td>
                      <td>{f.aciklama || ''}</td>
                      <td>
                        <span className={`badge badge-${f.aktif ? 'aktif' : 'pasif'}`}>
                          {f.aktif ? 'Aktif' : 'Pasif'}
                        </span>
                      </td>
                      <td style={{ display: 'flex', gap: 4 }}>
                        <button className="btn btn-sm"
                          style={{ background: f.aktif ? '#e67e22' : '#27ae60', color: 'white' }}
                          onClick={() => toggle(f.id, f.aktif)}>
                          {f.aktif ? 'Pasif Yap' : 'Aktif Et'}
                        </button>
                        <button className="btn btn-danger btn-sm" onClick={() => sil(f.id)}>Sil</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}

        {faaliyetler.length === 0 && (
          <div style={{ textAlign: 'center', color: '#999', padding: 30 }}>Kayıt bulunamadı</div>
        )}
      </div>

      {/* Modal */}
      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 520 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>➕ Yeni Faaliyet Ekle</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              {/* İşletme */}
              <div className="form-group">
                <label>İşletme *</label>
                <select className="form-control" value={form.isletme_id}
                  onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                  <option value="">Seçiniz</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad} ({i.kod})</option>)}
                </select>
              </div>

              {/* Modül */}
              <div className="form-group">
                <label>Modül / Faaliyet Türü *</label>
                <select className="form-control" value={form.modul}
                  onChange={e => setForm({ ...form, modul: e.target.value })}>
                  {Object.entries(MODUL_ADLARI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>

              {/* Kategori - hiyerarşik dropdown */}
              <div className="form-group">
                <label>Kategori / Irk / Ürün
                  <small style={{ color: '#888', fontWeight: 'normal', marginLeft: 6 }}>(isteğe bağlı)</small>
                </label>
                {tanimYukleniyor ? (
                  <div style={{ padding: '8px 0', color: '#aaa', fontSize: 12 }}>Yükleniyor...</div>
                ) : tanimListesi.length === 0 ? (
                  <div style={{ padding: '8px 0', color: '#aaa', fontSize: 12 }}>
                    Bu modül için tanım bulunamadı
                  </div>
                ) : (
                  <select className="form-control" value={form.kategori}
                    onChange={e => setForm({ ...form, kategori: e.target.value })}>
                    <option value="">— Seçiniz (boş bırakılabilir) —</option>
                    {tanimListesi.map(t => (
                      <option key={t.kod} value={t.ad}>
                        {t.gosterim}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              {/* Açıklama */}
              <div className="form-group">
                <label>Açıklama</label>
                <textarea className="form-control" value={form.aciklama}
                  onChange={e => setForm({ ...form, aciklama: e.target.value })}
                  rows={2} placeholder="İsteğe bağlı açıklama" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={ekle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
